import clsx from "clsx";
import Image from "next/image";

const linkIcons = {
	"LinkedIn": "/images/icons/linkedin.svg",
};

const SocialLinks = ({ links }) => {
  return (
    <div className={clsx("SocialLinks", "flex flex-wrap lg:flex-nowrap")}>
      {links.map((link) => {
				if (!link.url) return;

				return (
					<a
						key={link.label}
						href={link.url}
						target={link?.target ? link.target : "_blank"}
						className={clsx(
              "inline-block",
              "mt-4 mr-4 last-of-type:mr-0",
							(link.type === "icon") && [
								"flex items-center justify-center",
							],
							(link.type !== "icon") && [
								"PrimaryButton",
								"flex items-center justify-center",
								"h-10 px-5",
								"rounded-sm",
								"transition-colors",
								"bg-purple-01 hover:bg-black-01 text-white-01",
								"whitespace-nowrap"
							]
            )}
          >
						{(link.type === "icon") && (
							<Image
								src={linkIcons[link.label]}
								alt={link.label}
								width={40}
								height={40}
							/>
						)}
						{(link.type !== "icon") && (
							<span>{link.label}</span>
						)}
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
